import { render, staticRenderFns } from "./ElectronicGame.vue?vue&type=template&id=8aee3732&"
import script from "./ElectronicGame.vue?vue&type=script&lang=js&"
export * from "./ElectronicGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports